<script lang="ts">
  import { createContext } from 'reka-ui'
  import type { TenantUserDatabaseAccessGrantsService } from '@gat-ship/types/injection-keys'

  const [
    useTenantUserDatabaseAccessGrants,
    provideTenantUserDatabaseAccessGrants
  ] = createContext<TenantUserDatabaseAccessGrantsService>(
    'tenant-user-database-access-grants-provider'
  )

  export { useTenantUserDatabaseAccessGrants }
</script>

<script setup lang="ts">
  import { inject, onMounted, provide, watch } from 'vue'
  import { useTenantUserDatabaseAccessGrants as useTenantUserDatabaseAccessGrantsDataSource } from '../../composables/useTenantUserDatabaseAccessGrants'
  import { tenantUserDatabaseAccessGrantsKey } from '@gat-ship/types/injection-keys'

  const props = withDefaults(
    defineProps<{
      /** @default true */
      fetchOnMount?: boolean
      tenantUserId: string
    }>(),
    {
      fetchOnMount: true
    }
  )
  const dataSource =
    inject(tenantUserDatabaseAccessGrantsKey, undefined) ??
    useTenantUserDatabaseAccessGrantsDataSource()
  provide(tenantUserDatabaseAccessGrantsKey, dataSource)
  provideTenantUserDatabaseAccessGrants(dataSource)
  onMounted(() => {
    if (props.fetchOnMount) {
      dataSource.fetchData(props.tenantUserId)
    }
  })

  // The routed database-access page remounts this provider per user (route
  // param change), but the detail modal keeps it mounted and swaps the user via
  // the prop. Refetch the grants — and re-point the signalR filter — for the
  // newly selected user. fetchData no-ops when the id is unchanged, and the
  // subscription is idempotent, so this is safe and inert on the routed page.
  watch(
    () => props.tenantUserId,
    (tenantUserId) => {
      if (tenantUserId) {
        dataSource.fetchData(tenantUserId)
      }
    }
  )

  defineExpose(dataSource)
</script>
<template>
  <slot />
</template>
